import { Mail, Phone } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { WhatsAppIcon } from "@/components/WhatsAppIcon";
import { Email, EmailHref, FirmName, Phones, WhatsAppDisplay, buildWhatsAppUrl } from "@/data/SiteContent";

export default function Contact() {
  return (
    <section id="contacto" className="scroll-mt-20 bg-cream py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
        <Reveal className="mx-auto max-w-2xl text-center">
          <p className="text-xs font-medium uppercase tracking-[0.3em] text-gold-dark">Contacto</p>
          <h2 className="mt-4 font-serif text-3xl tracking-tight text-ink sm:text-4xl">
            {FirmName}
          </h2>
          <p className="mt-5 text-base leading-relaxed text-ash">
            Estamos a su disposición para atender sus consultas. Nuestro canal principal de
            atención es WhatsApp.
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-8 md:grid-cols-3">
          <Reveal>
            <div
              data-testid="contact-phones-card"
              className="h-full border-t-2 border-gold bg-white px-8 py-10 text-center shadow-sm"
            >
              <Phone className="mx-auto h-7 w-7 text-gold-dark" strokeWidth={1.5} aria-hidden="true" />
              <h3 className="mt-4 font-serif text-lg text-ink">Teléfonos</h3>
              <ul className="mt-3 space-y-2">
                {Phones.map((pPhone) => (
                  <li key={pPhone.Href}>
                    <a
                      href={pPhone.Href}
                      data-testid={`contact-phone-${pPhone.Label.replace(/\D/g, "")}`}
                      className="text-sm text-ash transition-colors duration-300 hover:text-gold-dark"
                    >
                      {pPhone.Label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>

          <Reveal Delay={120}>
            <div
              data-testid="contact-whatsapp-card"
              className="h-full border-t-2 border-gold bg-white px-8 py-10 text-center shadow-sm"
            >
              <WhatsAppIcon className="mx-auto h-7 w-7 text-gold-dark" />
              <h3 className="mt-4 font-serif text-lg text-ink">WhatsApp</h3>
              <a
                href={buildWhatsAppUrl()}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="contact-whatsapp-link"
                className="mt-3 inline-block text-sm text-ash transition-colors duration-300 hover:text-gold-dark"
              >
                {WhatsAppDisplay}
              </a>
              <p className="mt-2 text-xs text-ash/70">Canal principal de atención</p>
            </div>
          </Reveal>

          <Reveal Delay={240}>
            <div
              data-testid="contact-email-card"
              className="h-full border-t-2 border-gold bg-white px-8 py-10 text-center shadow-sm"
            >
              <Mail className="mx-auto h-7 w-7 text-gold-dark" strokeWidth={1.5} aria-hidden="true" />
              <h3 className="mt-4 font-serif text-lg text-ink">Correo electrónico</h3>
              <a
                href={EmailHref}
                data-testid="contact-email-link"
                className="mt-3 inline-block break-all text-sm text-ash transition-colors duration-300 hover:text-gold-dark"
              >
                {Email}
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
